<template>
  <div class="d-inline-block text-center">
    <v-dialog
      v-if="device"
      v-model="showState"
      max-width="480px"
    >
      <videon-card :heading="device.deviceName() + ' Streaming Status'" showClose="true" @close="showState = false">
        <v-card-text v-if="device.error" class="">
          <v-alert type="error">
            {{ device.errorText }}
          </v-alert>
        </v-card-text>
        
        <v-card-text v-if="device.state" class="px-5">
          <v-row>
            <videon-state-tile
              heading="Device Online"
              class="text-capitalize"
            >
              <span 
                :class="(!device.isOnline()) ? 'error--text' : ''"
              >
                {{ device.isOnline() }}
              </span>
            </videon-state-tile>
            <videon-state-tile
              heading="Last Boot"
            >
              {{ device.state.last_boot | moment("YYYY/MM/DD hh:mm:ss a") }}
            </videon-state-tile>
            <videon-state-tile
              heading="Device Uptime"
            >
              {{ uptime }}
            </videon-state-tile>
            <videon-state-tile
              heading="Last Update"
            >
              {{ device.state.last_state_update | moment("YYYY/MM/DD hh:mm:ss a") }}
            </videon-state-tile>
          </v-row>
          
          <div v-if="alerts.length > 0" class="ma-2">
            <v-row><h5 class="text--disabled">Device Alerts</h5></v-row>
            <v-row><v-divider /></v-row>
            <div>
              <v-row class="my-5">
                <ul class="ma-2">
                  <li 
                    v-for="alert in alerts" 
                    v-bind:key="alert.alert_guid" 
                    @click="$router.push('/devices/' + device.device_guid + '/config/Alerts'); showState = false"
                    style="cursor: pointer;"
                  >
                    <strong class="error--text">{{ alert.label }}</strong>
                    <v-chip v-if="alert.legacy" small outlined class="ml-1">
                      Legacy Alert
                    </v-chip>
                    <v-chip v-if="alert.silenced" small outlined class="ml-1">
                      Silenced
                    </v-chip>
                  </li>
                </ul>
              </v-row>
            </div>
          </div>
          
          <div v-if="device.isOnline() && srtConnected" class="ma-2">
            <v-row><h5 class="text--disabled">SRT Stats</h5></v-row>
            <v-row><v-divider /></v-row>
            <srt-stats :device_guid="device.device_guid" />
          </div>
        </v-card-text>
      </videon-card>
    </v-dialog>
    
    <v-chip :color="status.color" label outlined small @click="showState = true">
      <v-progress-circular :size="12" :width="1" v-if="loading" indeterminate color="grey"></v-progress-circular>
      <span v-else>
        {{ status.label }}
      </span>
    </v-chip>
  </div>
</template>

<script>
  import moment from 'moment'
  import SrtStats from '../../device/components/SRTStats.vue'
  
  export default {
    name: 'DecoderStreamingStatusLabel',
    
    components: {
      SrtStats
    },
    
    props: ['device', 'noSync'],
    
    computed: {
      inputsShadow() {
        return this.$deviceShadows.getDeviceShadow(this.device.device_guid, 'Inputs')
      },
      srtConnected() {
        if (this.inputsShadow.ready) {
          var state = this.inputsShadow.editableStateCopy()
          if (state.length > 0) {
            // I guess we only care about the first input for now...
            if (state[0].srt_input_connected) {
              return true
            }
          }
        }
        return false
      },
      loading() {
        if (this.device.isReady()) {
          if (this.device.error || (this.device.state && this.inputsShadow.ready)) {
            return false
          }
        }
        
        return true
      },
      alerts() {
        return this.$alerts.alertsForDevice(this.device.device_guid, true)
      },
      online() {
        return this.device.isOnline()
      },
      status() {
        if (!this.loading) {
          if (this.alerts.length > 0) {
            if (!this.device.isOnline()) {
              return {'label': 'Device Alerts', 'color': 'grey'}
            }
            return {'label': 'Device Alerts', 'color': 'red'}
          } else if (this.device.error) {
            return {'label': 'State Unknown', 'color': 'red'}
          } else if (!this.device.isOnline()) {
            return {'label': 'Device Offline', 'color': 'grey'}
          } else if (this.inputsShadow.ready) {
            if (this.srtConnected) {
              return {'label': 'SRT Input Connected', 'color': 'green'}
            } else {
              return {'label': 'SRT Input Not Connected', 'color': 'red'}
            }
          }
        }
        return {'label': 'Unknown', 'color': 'grey'}
      },
      uptime() {
        if (!this.device.isOnline()) {
          return 'Offline'
        } else if (this.device && this.device.state) {
          if (this.device.state.last_boot && this.device.last_api_request_id) {
            return moment(this.device.state.last_boot).fromNow(true)
          }
        }
        return 'Unknown'
      },
    },
    mounted() {
      this.syncDocuments()
    },
    beforeDestroy() {
      if (this.refreshTimer) {
        clearTimeout(this.refreshTimer)
        this.refreshTimer = false
      }
    },
    data() {
      return {
        showState: false,
        
        refreshTimer: false,
        refreshInterval: this.$helpers.getRefreshInterval(20000, 30000)
      }
    },
    methods: {
      inputName(shadowDocument) {
        if (shadowDocument.config.name) {
          return this.$helpers.htmlDecode(shadowDocument.config.name)
        }
        
        return 'Input #' + shadowDocument.id
      },
      syncDocuments() {
        if (this.device.state && !this.noSync) {
          console.log('DecoderStreamingStatusLabel ' + this.device.device_guid + ' syncDocuments')
          this.device.syncDocuments()
        }
        
        if (this.refreshInterval) {
          this.refreshTimer = setTimeout(() => {
            this.syncDocuments()
          }, this.refreshInterval)
        }
      }
    }
  }
</script>